import { LevelAdministrative } from "app/common/LocalConst";
import { AdministrativeUnit } from "app/common/Model/AdministrativeUnit";
import { SearchAdministrativeUnit } from "app/common/Model/SearchObject";
import {
    deleteAdministrativeUnit,
    generateHotKeyByLevel,
    getAdministrativeUnitById,
    getAllAdministrativeUnitByLevel,
    pagingAdministrativeUnit,
    saveAdministrativeUnit
} from "app/services/AdministrativeUnitService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import i18n from "i18n";
import { checkSearchObject } from "app/common/LocalFunction";

export default class AdministrativeUnitStore {
    listProvince = [];
    searchAdministrativeUnit = new SearchAdministrativeUnit();
    pageAdministrativeUnit = null;
    selectedAdministrativeUnit = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteAdministrativeUnit = false;
    recentlyUpdated = false;

    openFormCreateUrlAbbreviated = false

    constructor() {
        makeAutoObservable(this);
    }

    getProvince = () => {
        if (this.listProvince?.length === 0 || this.recentlyUpdated) {
            getAllAdministrativeUnitByLevel(LevelAdministrative.PROVINCE)
                .then(({ data }) => {
                    this.listProvince = data;
                    this.recentlyUpdated = true;
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Lấy dữ liệu tỉnh thành có lỗi");
                })
        }
    }

    pagingAdministrativeUnit = async () => {
        return await pagingAdministrativeUnit(this.searchAdministrativeUnit)
            .then(({ data }) => {
                this.pageAdministrativeUnit = data;
            }).catch(function (error) {
                console.error(error);
                toast.error(i18n.t("Lấy dữ liệu thất bại"));
            });
    }

    handleChangeFormSearch = searchObject => {
        this.searchAdministrativeUnit = checkSearchObject(this.searchAdministrativeUnit, searchObject);
        this.pagingAdministrativeUnit();
    }

    handleOpenFormCreateUrlAbbreviated = () => {
        this.selectedAdministrativeUnit = new AdministrativeUnit();
        this.openFormCreateUrlAbbreviated = true
    }

    saveUrlAbbreviated = async level => {
        try {
            await generateHotKeyByLevel({ level: level?.level })
            this.handleClosePopup()
            this.pagingAdministrativeUnit()
        } catch (error) {
            // console.log(error);
            toast.error('Lưu thất bại!')
        }
    }

    handleOpenFormCreateOrEdit = administrativeUnitId => {
        if (Boolean(administrativeUnitId)) {
            getAdministrativeUnitById(administrativeUnitId)
                .then(async ({ data: administrativeUnit }) => {
                    if (administrativeUnit.level === LevelAdministrative.WARD) {
                        administrativeUnit.district = administrativeUnit.parent;
                        await getAdministrativeUnitById(administrativeUnit.parent.id).then(({ data }) => administrativeUnit.province = data.parent);
                    } else if (administrativeUnit.level === LevelAdministrative.DISTRICTS) {
                        administrativeUnit.province = administrativeUnit.parent
                    }
                    this.selectedAdministrativeUnit = administrativeUnit;
                    this.openFormCreateOrEdit = true;
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Lấy dữ liệu đơn vị hành chính có lỗi");
                })
        } else {
            this.selectedAdministrativeUnit = new AdministrativeUnit();
            this.openFormCreateOrEdit = true;
        }
    }

    saveAdministrativeUnit = async (administrativeUnit, { setSubmitting }) => {
        if (administrativeUnit.level === LevelAdministrative.WARD) {
            administrativeUnit.parent = administrativeUnit.district;
        } else if (administrativeUnit.level === LevelAdministrative.DISTRICTS) {
            administrativeUnit.parent = administrativeUnit.province;
        } else {
            administrativeUnit.parent = null;
        }

        return await saveAdministrativeUnit(administrativeUnit)
            .then(({ data }) => {
                this.selectedAdministrativeUnit = null;
                toast.success("Lưu đơn vị hành chính thành công!");
                this.handleClosePopup();
                this.pagingAdministrativeUnit();
                this.recentlyUpdated = true;
                if (!administrativeUnit?.id && data?.level === LevelAdministrative?.PROVINCE) {
                    this.listProvince.push(data);
                }
            })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin đơn vị hành chính có lỗi");
            })
            .finally(() => setSubmitting(false));
    }

    handleDeleteAdministrativeUnit = (administrativeUnit) => {
        this.selectedAdministrativeUnit = { id: administrativeUnit?.id };
        this.openConfirmDeleteAdministrativeUnit = true;
    }

    handleConfirmDeleteAdministrativeUnit = async () => {
        return await (
            deleteAdministrativeUnit(this.selectedAdministrativeUnit?.id)
                .then(() => {
                    if (this.searchAdministrativeUnit?.pageIndex > 1 && this.pageAdministrativeUnit?.content?.length === 1) {
                        this.searchAdministrativeUnit.pageIndex -= 1;
                    }
                    toast.success("Xóa đơn vị hành chính thành công!")
                    this.handleClosePopup();
                    this.pagingAdministrativeUnit();
                    this.recentlyUpdated = true;
                    if (this.selectedAdministrativeUnit?.level === LevelAdministrative?.PROVINCE) {
                        this.listProvince = this.listProvince?.filter(e => e.id !== this.selectedAdministrativeUnit?.id)
                    }
                }).catch((error) => {
                    console.error(error);
                    toast.error('Đã có lỗi xảy ra vui lòng thử lại!')
                })
        )
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteAdministrativeUnit = false;
        this.openFormCreateUrlAbbreviated = false
    }

    resetStore = () => {
        this.searchAdministrativeUnit = new SearchAdministrativeUnit();
        this.pageAdministrativeUnit = null;
        this.selectedAdministrativeUnit = null;
        this.openFormCreateOrEdit = null;
        this.openConfirmDeleteAdministrativeUnit = null;
    }
}